import { Injectable } from '@angular/core';

@Injectable()
export class ContentService {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/services/content.service.ts